var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeneralBodySystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.5H21.75C19.679 16.5 18 14.821 18 12.75V5.25C18 3.17897 19.679 1.5 21.75 1.5H26.25C28.321 1.5 30 3.17897 30 5.25V12.75C30 14.821 28.321 16.5 26.25 16.5Z",
    fill: "#FAB991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18H15C12.5147 18 10.5 20.0147 10.5 22.5V28.5H15V46.5H22.5V45H25.5V46.5H33V28.5H37.5V22.5C37.5 20.0147 35.4853 18 33 18Z",
    fill: "#FAB991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.5H26.25V18H21.75V16.5Z",
    fill: "#F0915A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.5V28.5H14V26.5C14 25.9477 14.4478 25.5 15 25.5Z",
    fill: "#F0915A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 43.5V46.5H25.5V44.5C25.5 43.9477 25.9477 43.5 26.5 43.5Z",
    fill: "#F0915A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43.5V46.5H22.5V44.5C22.5 43.9477 22.0523 43.5 21.5 43.5Z",
    fill: "#F0915A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 25.5V28.5H34V26.5C34 25.9477 33.5523 25.5 33 25.5Z",
    fill: "#F0915A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H24V1.5H21.75C19.679 1.5 18 3.17897 18 5.25V6Z",
    fill: "#FAC3C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.5H26.25C28.321 1.5 30 3.17897 30 5.25V9C29.5858 9 29.25 8.66419 29.25 8.25V6C29.25 4.75734 28.2427 3.75 27 3.75H24V1.5Z",
    fill: "#555A6E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.5H24V6H18V12.75C18 14.821 19.679 16.5 21.75 16.5Z",
    fill: "#D7E6F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12V9C30.8285 9 31.5 9.67153 31.5 10.5C31.5 11.3285 30.8285 12 30 12Z",
    fill: "#F0915A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12V9C17.1715 9 16.5 9.67153 16.5 10.5C16.5 11.3285 17.1715 12 18 12Z",
    fill: "#F0915A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5C21.8284 10.5 22.5 9.82843 22.5 9C22.5 8.17157 21.8284 7.5 21 7.5C20.1716 7.5 19.5 8.17157 19.5 9C19.5 9.82843 20.1716 10.5 21 10.5Z",
    fill: "#555A6E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9.75C27.4142 9.75 27.75 9.41421 27.75 9C27.75 8.58579 27.4142 8.25 27 8.25C26.5858 8.25 26.25 8.58579 26.25 9C26.25 9.41421 26.5858 9.75 27 9.75Z",
    fill: "#555A6E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16.1871V14.25C20.25 13.0073 19.2427 12 18 12V12.75C18 14.2876 18.9258 15.6083 20.25 16.1871Z",
    fill: "#555A6E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 14.25H24V12.75H21.75C21.3358 12.75 21 13.0858 21 13.5C21 13.9142 21.3358 14.25 21.75 14.25Z",
    fill: "#A5C3DC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.75H25.75C26.0261 13.75 26.25 13.5261 26.25 13.25H24V13.75Z",
    fill: "#555A6E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.625C20.7929 2.625 20.625 2.79291 20.625 3C20.625 3.20709 20.7929 3.375 21 3.375H21.875C22.2885 3.375 22.625 3.03853 22.625 2.625V1.5H21.875V2.625H21Z",
    fill: "#F58CAA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 5.37497C21.207 5.37497 21.3749 5.20706 21.3749 4.99997C21.3749 4.79288 21.207 4.62497 20.9999 4.62497H19.8749V4.125C19.8749 3.71147 19.5385 3.375 19.1249 3.375H18.5029C18.3668 3.61022 18.2548 3.86109 18.1719 4.125H19.1249V6H19.8749V5.37497H20.9999Z",
    fill: "#F58CAA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.875C22.7929 3.875 22.625 4.04291 22.625 4.25C22.625 4.45709 22.7929 4.625 23 4.625H24V3.875H23Z",
    fill: "#F58CAA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12V9.75C24.4142 9.75 24.75 10.0858 24.75 10.5V11.25C24.75 11.6642 24.4142 12 24 12Z",
    fill: "#F0915A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12V9.75C23.5858 9.75 23.25 10.0858 23.25 10.5V11.25C23.25 11.6642 23.5858 12 24 12Z",
    fill: "#555A6E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 43.5H18C17.1715 43.5 16.5 42.8285 16.5 42V25.5C16.5 22.1863 19.1863 19.5 22.5 19.5H25.5C28.8137 19.5 31.5 22.1863 31.5 25.5V42C31.5 42.8285 30.8285 43.5 30 43.5Z",
    fill: "#555A6E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41.25H21C19.7573 41.25 18.75 40.2427 18.75 39C18.75 37.7573 19.7573 36.75 21 36.75H27C28.2427 36.75 29.25 37.7573 29.25 39C29.25 40.2427 28.2427 41.25 27 41.25Z",
    fill: "#F05A4B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 36.75C24.2763 36.75 24.5 36.9739 24.5 37.25V40.25H23.5V37.25C23.5001 36.9739 23.7239 36.75 24.0001 36.75Z",
    fill: "#D73728"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 38.5C22.2763 38.5 22.5 38.7239 22.5 39V41.25H21.5V39C21.5 38.7238 21.7239 38.5 22.0001 38.5Z",
    fill: "#D73728"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 36.75H20.5V38.5C20.5 38.7761 20.2762 39 20.0001 39C19.7239 39 19.5001 38.7761 19.5001 38.5V36.75H19.5Z",
    fill: "#D73728"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38.5C25.7238 38.5 25.5 38.7239 25.5 39V41.25H26.5V39C26.5 38.7238 26.2762 38.5 26 38.5Z",
    fill: "#D73728"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36.75H27.5V38.5C27.5 38.7761 27.7239 39 28 39C28.2761 39 28.4999 38.7761 28.4999 38.5V36.75H28.5Z",
    fill: "#D73728"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.75V31.5H22.5C23.7427 31.5 24.75 32.5073 24.75 33.75C24.75 34.9927 23.7427 36 22.5 36H21V36.75H27C28.6568 36.75 30 35.4068 30 33.75C30 32.0932 28.6568 30.75 27 30.75H21Z",
    fill: "#F58CAA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.75V32.25C27 33.0785 27.6715 33.75 28.5 33.75H30C30 32.0932 28.6568 30.75 27 30.75Z",
    fill: "#FAC3C8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30H21.75C22.5785 30 23.25 29.3285 23.25 28.5V21H22.5C20.0147 21 18 23.0147 18 25.5V28.5C18 29.3285 18.6715 30 19.5 30Z",
    fill: "#F05A4B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 28.5H19.5C18.6715 28.5 18 27.8285 18 27V28.5C18 29.3285 18.6715 30 19.5 30H21.75C22.5785 30 23.25 29.3285 23.25 28.5V27C23.25 27.8285 22.5785 28.5 21.75 28.5Z",
    fill: "#D73728"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30H26.25C25.4215 30 24.75 29.3285 24.75 28.5V21H25.5C27.9853 21 30 23.0147 30 25.5V28.5C30 29.3285 29.3285 30 28.5 30Z",
    fill: "#F05A4B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 28.5H28.5C29.3285 28.5 30 27.8285 30 27V28.5C30 29.3285 29.3285 30 28.5 30H26.25C25.4215 30 24.75 29.3285 24.75 28.5V27C24.75 27.8285 25.4215 28.5 26.25 28.5Z",
    fill: "#D73728"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 21V16.5H23.25V21C22.4229 21 21.75 21.6729 21.75 22.5V24C21.75 24.4142 22.0858 24.75 22.5 24.75C22.9142 24.75 23.25 24.4142 23.25 24V22.5H24.75V24C24.75 24.4142 25.0858 24.75 25.5 24.75C25.9142 24.75 26.25 24.4142 26.25 24V22.5C26.25 21.6729 25.5771 21 24.75 21Z",
    fill: "#FAC3C8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25C25.6233 25 25.2954 25.2085 25.125 25.5163C24.9545 25.2085 24.6267 25 24.25 25C23.6977 25 23.25 25.4478 23.25 26V27C23.25 28.6568 24.5932 30 26.25 30C26.6642 30 27 29.6642 27 29.25V25.9999C27 25.4477 26.5523 25 26 25Z",
    fill: "#F58CAA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1779 36H18.75C18.3358 36 18 35.6642 18 35.25V33C18 31.3432 19.3432 30 21 30H27C27.4142 30 27.75 30.3358 27.75 30.75C27.75 31.2124 27.4974 31.6377 27.0916 31.8592L19.7828 35.8458C19.5972 35.9469 19.3892 36 19.1779 36Z",
    fill: "#DC6950"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 31.25V34.5L27.0916 31.8592C27.4974 31.6377 27.75 31.2124 27.75 30.75C27.75 30.3358 27.4142 30 27 30H21C21.6904 30 22.25 30.5597 22.25 31.25Z",
    fill: "#C85541"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27 36H21C19.3458 36 18 37.3458 18 39C18 40.6542 19.3458 42 21 42H21.75C22.1642 42 22.5 41.6642 22.5 41.25C22.5 40.8358 22.1642 40.5 21.75 40.5H21C20.1729 40.5 19.5 39.8271 19.5 39C19.5 38.1729 20.1729 37.5 21 37.5H27C27.8271 37.5 28.5 38.1729 28.5 39C28.5 39.8271 27.8271 40.5 27 40.5H26.25C24.5958 40.5 23.25 41.8458 23.25 43.5H24.75C24.75 42.6729 25.4229 42 26.25 42H27C28.6542 42 30 40.6542 30 39C30 37.3458 28.6542 36 27 36Z",
    fill: "#FAC3C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneralBodySystems);
export default __webpack_public_path__ + "static/media/icon-general-body-systems.ef522a6b5f4acae3ab6066758d6437cb.svg";
export { ForwardRef as ReactComponent };